define.alias("ember-power-select/components/power-select/label", "settings/components/power-select/label");